import React from 'react';

import StringQuestionEditor, { Props as EditorProps } from './StringQuestionEditor';
import StringQuestionInput, { Props as InputProps } from './StringQuestionInput';

type EditProps = EditorProps & {
  mode: 'edit';
};

type ViewProps = Pick<InputProps, 'question'> & {
  mode: 'view';
}

type SubmitProps = InputProps & {
  mode: 'submit';
  enrollmentId: number;
  sectionId: number;
  caseId?: number;
}

type Props = EditProps | ViewProps | SubmitProps;

const StringQuestion: React.FC<Props> = (props: Props) => {
  const { mode } = props;
  if (mode === 'edit') {
    const {
      surveyId,
      sectionId,
      question,
      addQuestion,
      updateQuestion,
      onCancelEdit,
      disableHideAggregation,
    } = props as EditProps;
    return (
      <StringQuestionEditor
        surveyId={surveyId}
        sectionId={sectionId}
        question={question}
        addQuestion={addQuestion}
        updateQuestion={updateQuestion}
        onCancelEdit={onCancelEdit}
        disableHideAggregation={disableHideAggregation}
      />
    );
  }

  if (mode === 'view') {
    const {
      question,
    } = props as ViewProps;
    return (
      <StringQuestionInput
        question={question}
      />
    );
  }

  if (mode === 'submit') {
    const {
      caseId,
      enrollmentId,
      sectionId,
      question,
      defaultSubmission,
      disabled,
      required,
      onSave,
      getSaveStatus,
      manualSave,
      saveOnBlur,
    } = props as SubmitProps;
    return (
      <StringQuestionInput
        question={question}
        defaultSubmission={defaultSubmission}
        disabled={disabled}
        onSave={onSave}
        required={required}
        caseId={caseId}
        enrollmentId={enrollmentId}
        sectionId={sectionId}
        getSaveStatus={getSaveStatus}
        manualSave={manualSave}
        saveOnBlur={saveOnBlur}
      />
    );
  }

  return null;
};

export default StringQuestion;
